import { useEffect, useState } from "react";
import { Customer } from "../components/models/customer/Customer";
import { ICustomer } from "../components/models/customer/ICustomer";
import { getCustomerById, getCustomers, getCustomerTransactions } from "../api/requests";
import { ISelectDropdownItem } from "../components/form-control/SelectDropdown";
import { ITransaction, Transaction } from "../components/models/transaction/Transaction";
import { CUSTOMER_TYPES } from "../resources/enums";
import { ITablePaginationData } from "../components/elements/GTable/GTable";
import { getPaginationDataFromResponse } from "../utilities/miscFunctions";

function useCustomers() {
    const [loadingCustomers, setLoadingCustomers] = useState<boolean>(true);
    const [customers, setCustomers] = useState<Customer[]>([]);
    const [refreshing, setRefreshing] = useState<boolean>(true);
    const [customer, setCustomer] = useState<Customer>();
    const [customerTransactions, setTransactions] = useState<Transaction[]>([]);

    const CUSTOMERS_LIST_FOR_FORM = customers.map((customer: Customer): ISelectDropdownItem => (
        {
            id: customer.id,
            name: customer.name,
            value: customer.id,
        }
    ))

    const [paginationData, setPaginationData] = useState<ITablePaginationData>({
        total: 0,
        per_page: 0,
        total_pages: 0,
        current_page: 1,
        to: 0,
        from: 0
    });

    const fetchCustomers = ({ query, limit = 25, type, agentId, from, to, page, branchId }: {
        query?: string,
        limit?: number,
        type?: CUSTOMER_TYPES,
        agentId?: string,
        from?: string,
        to?: string,
        page?: number,
        branchId?: string,
    }) => {
        setRefreshing(true);
        getCustomers(query, limit, type, agentId, from, to, page, branchId)
            .then((response: any) => {
                const _customers = response?.data?.map((_account: ICustomer) => new Customer(_account));
                setCustomers(_customers);

                setPaginationData(getPaginationDataFromResponse(response));
            }).catch((error: any) => {
                console.log("request error", error);
            }).finally(() => {
                setLoadingCustomers(false);
                setRefreshing(false);
            })
    }

    const fetchCustomerById = (customerId: string) => {
        getCustomerById(customerId)
            .then((response: any) => {
                setCustomer(new Customer(response));
            }).catch((error: any) => {
                console.log("request error", error);
            }).finally(() => {
                setLoadingCustomers(false);
                setRefreshing(false);
            })
    }

    const fetchCustomerTransactions = (customerId: string, query = "", limit = 10) => {
        getCustomerTransactions(customerId, query, limit)
            .then((response: any) => {
                const _transactions = response?.map((ITransaction: ITransaction) => new Transaction(ITransaction));
                setTransactions(_transactions);
            }).catch((error: any) => {
                console.log("request error", error);
            }).finally(() => {
                // setLoadingTransactions(false);
                setRefreshing(false);
            })
    }

    return { customers, loadingCustomers, CUSTOMERS_LIST_FOR_FORM, refreshing, fetchCustomers, customer, fetchCustomerById, fetchCustomerTransactions, customerTransactions, setTransactions, setCustomer, paginationData };

}

export default useCustomers;

